module.exports = __webpack_public_path__ + "img/Trampolin.3763cb80.jpg";